import React, {Component, Fragment} from 'react';
import {withTranslation} from 'react-i18next';
import {reactTableText} from '../../../../constants/configs';
import ModalManager from '../../../../components/modal/ModalManager';
import TokenTagsManageForm from "../../../../containers/TokenTagsManageForm";
import ReactTableSelectFilter from "../../../../components/ReactTableSelectFilter";
import {store} from "../../../../AppRenderer";
import Rbac from '../../../../components/Rbac';
import Api from '../../../../services/Api';
import ReactTable from 'react-table';
import {join, map} from 'lodash';

class TokensList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tokens: [],
      original: [],
      loading: true,
    };
    this.renderTokenFilter = this.renderTokenFilter.bind(this);
  }

  async componentDidMount() {
    await this.fetchData();
  }

  fetchData = async () => {
    try {
      const {data} = await Api.invoke('GET', '/v2/tokens');
      this.setState({
        tokens: data,
        original: data,
      });
    } catch (e) {
      console.log('error: ', e);
    } finally {
      this.setState({
        loading: false,
      });
    }
  };

  onPressEdit = token => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Edit {{name}} token tags', {name: token.symbol}),
      body: <TokenTagsManageForm token={token} afterSubmit={this.fetchData}/>
    });
  };

  renderTokenFilter({filter, onChange}) {
    const {t} = this.props;
    const options = store.getState().general.tokens.map(token => ({
      value: token.symbol, label: token.symbol,
    }));
    return <ReactTableSelectFilter
      filter={filter}
      onChange={value => {
        onChange(value);
        this.onSelectToken(value);
      }}
      options={[
        {value: '', label: t('all')},
        ...options,
      ]}
    />;
  }

  onSelectToken = selected => {
    this.setState(({original}) => ({
      tokens: selected ?
        original.filter(item => item.symbol === selected)
        :
        original
    }));
  };

  getColumns = t => [
    {
      Header: t('Name'),
      accessor: 'symbol',
      className: 'font-weight-semibold',
      width: 150,
      filterable: true,
      Filter: this.renderTokenFilter,
    },
    {
      Header: t('Categories'),
      accessor: 'tags',
      Cell: props => {
        if (props.value) {
          return <span>{join(map(props.value, item => item.name), ', ')}</span>;
        }
        return null;
      }
    },
    {
      Header: t('Actions'),
      accessor: 'symbol',
      Cell: props => <div className='d-flex flex-row align-items-center'>
        <i
          className="simple-icon-pencil edit-icon mr-4 cursor-pointer"
          onClick={() => {this.onPressEdit(props.original);}}
        />
      </div>,
      width: 70,
      show: Rbac.hasPermission('update_tag'),
    },
  ];

  render() {
    const {t} = this.props;
    return (
      <Fragment>
        <ReactTable
          manual
          className="-highlight"
          data={this.state.tokens}
          loading={this.state.loading}
          sortable={false}
          resizable={true}
          showPagination={false}
          columns={this.getColumns(t)}
          pageSize={this.state.tokens.length || 5}
          style={{
            width: '100%',
          }}
          {...reactTableText}
        />
      </Fragment>
    );
  }
}

export default withTranslation()(TokensList);
